import { Component } from 'san';
import * as echarts from 'echarts';
import * as _ from 'lodash';
import * as moment from 'moment';

export default class DashboardLine extends Component {
    myChart: echarts.ECharts;
    constructor(options: any) {
        super(options);
    }

    initData(): {
        xAxis: string[];
        series: [];
    } {
        return {
            xAxis: [],
            series: [],
        };
    }

    inited() {}

    attached() {
        this.initChart();

        // 监听，若widget大小发生变化，chart resize
        const elem = document.getElementById(`chart-${this.data.get('type')}`);
        const resizeObserver = new ResizeObserver(() => {
            this.myChart.resize();
        });
        resizeObserver.observe(elem);
    }

    initChart() {
        const type = this.data.get('type');
        this.initItems();
        const chartDom = document.getElementById(`chart-${type}`);
        const dashboardData = this.data.get('items');
        let items = [];
        _.forEach(dashboardData, dashboardItem=> {
            items = _.concat(items, dashboardItem.items)
        })
        const hasData = !!items.length;
        if (chartDom) {
            echarts.dispose(document.getElementById(`chart-${type}`));
        }
        this.myChart = echarts.init(chartDom);
        const option = {
            tooltip: {
                trigger: 'item',
            },
            xAxis: {
                show: hasData,
                type: 'category',
                data: this.data.get('xAxis'),
            },
            yAxis: {
                show: hasData,
                type: 'value',
                name: "单位（个）",
                minInterval:1
            },
            legend: {
                orient: 'vertical',
                top: 'center',
                right: '16',
            },
            title: {
                text: type,
                left: '16',
                top: '4',
                textStyle: {
                    color: '#1A1A1A',
                    fontWeight: 'normal',
                    fontSize: '14',
                },
            },
            graphic: {
                type: 'text',
                left: 'center',
                top: 'center',
                style:{
                    text: !hasData ? "暂无数据" : "",
                    fill:"#c0c0c0",
                    fontSize: 16
                }
            },
            grid: {
                left: '10%',
                right: '10%',
                bottom: '3%',
                containLabel: true,
            },
            series: hasData ? this.data.get('series'): [],
        };

        option && this.myChart.setOption(option);
    }

    initItems() {
        const dashboardData = this.data.get('items');
        const xAxis = [];
        for (let i = 0; i < 30; i++) {
            const day = moment()
                .subtract(29 - i, 'days')
                .format('YYYY-MM-DD');
            xAxis.push(day);
        }
        this.data.set('xAxis', xAxis);
        const series = [];
        const colors = ['#95CA79', '#5473C3'];
        _.forEach(dashboardData, (dashboardItem, i) => {
            const yAxis = [];
            _.forEach(xAxis, (x) => {
                const item = _.find(dashboardItem?.items, { key: x });
                yAxis.push(item ? item.value : 0);
            });
            series.push({
                name: dashboardItem.type,
                data: yAxis,
                type: 'line',
                smooth: true,
                color: colors[i],
                itemStyle: {
                    normal: {
                        label: {
                            show: true,
                            formatter(val: any) {
                                return val.value || '';
                            },
                        },
                    },
                },
            })
            this.data.set('series', series);
        });
    }
}
